{
  "staff-selection-dialog": {
    "buttons": {
      "close": "Fermer",
      "select": "Sélectionner",
      "selected": "Sélectionné"
    },
    "text": {
      "title": "Sélection du personnel",
      "first-available": "Premier personnel disponible"
    }
  }
}
